import queryString from 'query-string';

import type { JourneyParameters, JourneyType } from '~types/navigation';

export const getParamsFromBigBrowseUrl = (
  path: string
): JourneyParameters | undefined => {
  const [urlPath, urlParamsString] = path.split('?');
  const urlParams = queryString.parse(urlParamsString, {
    parseNumbers: true,
  });

  const [_root, route, journey, journeyParam] = urlPath.split('/');

  if (route !== 'bb') {
    return undefined;
  }

  return {
    journey: journey as JourneyType,
    journeyParam: Number(journeyParam) || undefined,
    ...urlParams,
  };
};

type HistoryEntry = {
  key: string;
  path?: string;
};

export const injectHistoryPath = async (
  entries: [HistoryEntry, HistoryEntry]
) => {
  if (!window?.history) {
    return;
  }

  const [base, top] = entries;

  window.history.replaceState(base.key, '', base.path);
  window.history.pushState(top.key, '', top.path);
};

export const getDestinationSignature = (params: JourneyParameters): string => {
  const { journey, journeyParam = 0, productId = 0 } = params;

  return [journey, journeyParam, productId].join('_');
};

export const normalizeParams = (
  input?: Record<string, string>
): Record<string, number | string> | undefined => {
  if (!input) {
    return undefined;
  }

  const result: Record<string, number | string> = {};
  Object.keys(input).forEach((key) => {
    const value = input[key];
    result[key] = Number.isNaN(Number(value)) ? value : Number(value);
  });

  return result;
};
